import crypto from 'crypto'

import { createContext, useContext } from 'react'

export const NonceContext = createContext<string>('')
export const NonceProvider = NonceContext.Provider
export const generateNonce = () => crypto.randomBytes(32).toString('base64')
export const useNonce = () => useContext(NonceContext)
